import React from "react";
import { Link, useParams } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { useI18n } from "../i18n";
import { ChevronLeft } from "lucide-react";

export default function Legal({ doc }) {
  const { t } = useI18n();
  const params = useParams();
  const which = doc || params.doc || "privacy";
  const data = t.legal[which] || t.legal.privacy;

  return (
    <div className="min-h-screen bg-deep flex flex-col">
      <Nav />
      <div className="max-w-3xl mx-auto px-6 py-12 w-full flex-1" data-testid={`legal-${which}-page`}>
        <Link to="/" className="btn-outline !py-1.5 text-xs mb-6"><ChevronLeft className="w-3.5 h-3.5" /> {t.auth.back}</Link>
        <div className="chip chip-violet inline-flex">{data.tag}</div>
        <h1 className="font-heading text-4xl tracking-tight mt-3">{data.title}</h1>
        <p className="text-zinc-500 mt-2 text-xs font-mono">{t.legal.lastUpdate}: 12/05/2026</p>

        <div className="mt-8 space-y-6 text-sm text-zinc-300 leading-relaxed">
          {data.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading font-bold text-lg text-neon-cyan mb-2">{s.h}</h2>
              {s.p.map((para, j) => (<p key={j} className="mb-3 text-zinc-300">{para}</p>))}
              {s.list && (
                <ul className="list-disc pl-5 space-y-1 text-zinc-400">
                  {s.list.map((li, k) => (<li key={k}>{li}</li>))}
                </ul>
              )}
            </section>
          ))}

          <section className="card-neon p-5">
            <h2 className="font-heading font-bold text-lg text-neon-yellow mb-2">{t.legal.contactTitle}</h2>
            <p className="text-zinc-300">
              <strong>RENOVA360</strong> è un prodotto <strong>Makai</strong> · P.IVA <span className="font-mono">09936410969</span>
            </p>
            <p className="text-zinc-400 mt-2">Email: <a href="mailto:renova360@renova360.it" className="text-neon-cyan hover:underline">renova360@renova360.it</a></p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
